export default __webpack_public_path__ + "static/media/Group5158-1d62888b4b662af9142e3c385f423f32.bcf7c26a.svg";